'use client';

import {type FC, useEffect, useRef} from 'react';
import clsx from 'clsx';

import type {ContentBlockContainerProps} from '@/modules/page/components/content-blocks/block-container';
import {ContentBlockContainer} from '@/modules/page/components/content-blocks/block-container';

type Props = ContentBlockContainerProps & {
	insideToc?: boolean;
};

export const CookieList: FC<Props> = ({options, insideToc}) => {
	const containerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (containerRef.current) {
			const script = document.createElement('script');
			script.type = 'text/javascript';
			script.src = `//report.cookie-script.com/r/d8481697e816f2d580eed3e507e84b3b.js`;
			script.setAttribute('data-cookiescriptreport', 'report');
			containerRef.current.appendChild(script);
		}
	}, []);

	return (
		<ContentBlockContainer
			options={options}
			width={options?.fullWidth ? 'screen' : (options?.width ?? 'text')}
			insideToc={insideToc}
		>
			<div
				ref={containerRef}
				className={clsx(
					'[&_h4]:font-display',
					'[&_h4]:font-medium',
					'[&_h4]:text-[17px]',
					'[&_h4]:leading-tight',
					'[&_h4]:mb-2',
					'[&_h4]:scroll-m-14',
					'[&_h4]:mt-8',
					'first-of-type:[&_h4]:mt-0',
					'overflow-x-auto',
				)}
			/>
		</ContentBlockContainer>
	);
};
